import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  private queryParams: any = {};

  constructor() {}

  setQueryParams(params: any): void {
    this.queryParams = params;
  }

  getQueryParams(): any {
    return this.queryParams;
  }
}
